module.exports = __webpack_public_path__ + "img/sb02-05.f1434630.png";